const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const normalizarEmail = (email: string): string => email.trim().toLowerCase()

export const emailValido = (email?: string | null): boolean => !!email && REGEX_EMAIL.test(normalizarEmail(email))

/** o campo de login aceita CIM ou e-mail: e-mail é o que tem @ */
export const éLoginPorEmail = (login: unknown): login is string => typeof login === 'string' && login.includes('@')
